<template>
  <div v-if="updateAvailable" class="aviso-nueva-version" role="status" aria-live="polite">
    <span class="aviso-nueva-version__texto">
      <i class="bi bi-arrow-repeat" aria-hidden="true"></i>
      Hay una nueva versión del sistema
    </span>
    <button type="button" class="btn btn-sm btn-light fw-semibold" :disabled="asking" @click="onActualizar">
      ACTUALIZAR A LA ÚLTIMA VERSIÓN
    </button>
  </div>
</template>

<script setup>
// Aviso no modal: la recarga sólo ocurre si el usuario confirma (RN-1,
// docs/aviso-nueva-version-spec.md).
import { ref } from 'vue'
import { updateAvailable, applyUpdate } from '@/services/appVersionService'

const asking = ref(false)

const onActualizar = async () => {
  asking.value = true
  try {
    const ok = await window.confirm('La página se va a recargar con la última versión del sistema.', {
      title: '¿Actualizar ahora?',
      confirmText: 'Sí, actualizar',
      cancelText: 'No, más tarde'
    })
    if (ok) await applyUpdate()
  } finally {
    asking.value = false
  }
}
</script>

<style scoped>
.aviso-nueva-version {
  position: fixed;
  left: 1rem;
  bottom: 1rem;
  z-index: 1040;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 0.75rem;
  max-width: calc(100vw - 2rem);
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  background: #0d6efd;
  color: #fff;
  font-size: 0.9rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.2);
}

.aviso-nueva-version__texto {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

@media print {
  .aviso-nueva-version {
    display: none;
  }
}
</style>
